import {
  aggregationBulkGrantsSchema,
  aggregationEndDateTimeSchema,
  aggregationStartDateTimeSchema,
  aggregationWalletServicesSchema,
} from './aggregation';

import { BulkGrantAggregationCriteriaKey } from '@/types';
import {
  InferType,
  object,
  string,
} from '@/validations/custom-yup';

export const bulkGrantAggregationCriteriaSchema = string<BulkGrantAggregationCriteriaKey>()
  .label('集計基準')
  .required(({ label }) => `${label}を選択してください。`);

export const bulkGrantAggregationFilterSchema = object({
  walletServices: aggregationWalletServicesSchema,
  bulkGrants: aggregationBulkGrantsSchema,
});
export type BulkGrantAggregationFilterSchema = InferType<typeof bulkGrantAggregationFilterSchema>;

export const bulkGrantAggregationUiFormSchema = object({
  startDateTime: aggregationStartDateTimeSchema,
  endDateTime: aggregationEndDateTimeSchema,
  criteria: bulkGrantAggregationCriteriaSchema,
  filter: bulkGrantAggregationFilterSchema,
});
export type BulkGrantAggregationUiFormSchema = InferType<typeof bulkGrantAggregationUiFormSchema>;
